<template>
  <footer class="main-page-footer">
    <div class="top_info">
      <img class="logo" :src="require('@/assets/home/logo.png')" alt="" />
      <div class="contract">
        <div class="line"></div>
        <span>{{ $t("footer.us") }}</span>
        <img :src="require('@/assets/home/fb.png')" alt="" />
        <img :src="require('@/assets/home/in.png')" alt="" />
        <img :src="require('@/assets/home/zalo.png')" alt="" />
      </div>
    </div>
    <div class="bottom"></div>
    <div class="bottomInfo">Copyright©2019-2024 All Rights Reserved.</div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
import event from "@/event";
export default {
  name: "live-footer",
  data() {
    return {
      android_address: "",
      linkList: [],
      anchorData: [],
      bottomData: [], //我们 | 联系客服 | 我要直播 | 帮助中心 | 版权保护投诉指引
      appDevice: "iphone",
      aboutUs: "",
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.main-page-footer {
  width: 100%;
  
  background-color: rgba(38, 29, 29, 1);
  .top_info {
    padding: 0 2rem;
    height: 1.02rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 1.2rem;
    }
    .contract {
      display: flex;
      align-items: center;
      .line {
        width: 2px;
        height: 0.24rem;
        background-color: rgba(208, 45, 84, 1);
        margin-right: 0.08rem;
      }
      span {
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.16rem;
      }
      img {
        margin-left: 0.2rem;
        width: 0.32rem;
      }
    }
  }
  .bottom {
    width: calc(100% - 4rem);
    margin: 0 auto;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
  }
  .bottomInfo {
    font-size: 0.14rem;
    color: rgba(255, 255, 255, 0.4);
    text-align: center;
    margin-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
}
</style>
